import {combineReducers} from "redux";
import userReducer from "./user";
import currentEventReducer from "./currentEvent";
import clientReducer from "./client";

// Combine Reducers
const reducers = combineReducers({
	user: userReducer,
	currentEvent: currentEventReducer,
	client: clientReducer
});

export default reducers;
